module.exports = __webpack_public_path__ + "static/rockdance-poster-3cba8c4e05061679f422d009aed8783f.jpg";